function RelookingGallery(){

    this.build();

}

RelookingGallery.prototype.build = function(){

    let that = this;

    const gelleryItems = document.querySelectorAll(".relooking-link-gallery");
    gelleryItems.forEach(item => {
        item.addEventListener("click", that.constructGallery.bind(this));
    });

};


RelookingGallery.prototype.constructGallery = function(e){

    gallery.arrows = false;
    gallery.middleTop = false;
    gallery.construct();

    let that = this;
    that.imageContainer = $('<div class="before-after"></div>');
    that.target = e.currentTarget;

    $(window).on('overlayDone', function(){
        that.images = $(that.target).find(".relooking-images-gallery");
        that.imagesLength = that.images.length;

        gallery.containerMiddleCenter.append( that.imageContainer );
        that.loadImage( that.images[0], 0 );
    });

};

RelookingGallery.prototype.loadImage = function(image, cpt){

    let that = this;

    let src = $(image).data('relooking-images-gallery');

    let imageHtml = "<img src='"+ src +"'>";
    let img = $(imageHtml);

    if( $(image).data('relooking-images-title') ){
        this.content = "<div class='text-center'>";
        this.content += "<h2 class='title-lev2'>"+$(image).data('relooking-images-title')+"</h2>";
        this.content += "<p>"+$(image).data('relooking-images-desc')+"</p>";
        this.content += "</div>";
        gallery.containerMiddleBottom.empty().append(this.content);
    }

    img.on('load', function(){

        that.imageContainer.append( img );

        if( cpt === 0 ) {
            let width = ( img.width() >= window.innerWidth ) ? window.innerWidth * 0.8 + 'px' : img.width();
            that.imageContainer.css('width', width);
        }

        if( cpt < that.imagesLength - 1 ){
            cpt++;
            that.loadImage( that.images[ cpt ], cpt );
        }else{
            that.initGallery();
        }
    }).attr("src", src);

};

RelookingGallery.prototype.initGallery = function(){

    let that = this;

    that.imageContainer.twentytwenty();

    gallery.initAnimation();

    $(window).on('initDone', function(){

        const sliderItems = document.querySelectorAll(".twentytwenty-handle");
        sliderItems.forEach(item => {
            item.addEventListener("mouseenter", mouseAnimation.twentytwentyMouseEnter.bind(mouseAnimation));
            item.addEventListener("mousedown", mouseAnimation.twentytwentyMouseDown.bind(mouseAnimation));
            item.addEventListener("mouseleave", mouseAnimation.mouseLeave.bind(mouseAnimation));
        });

        gallery.close.on('click', function(){
            gsap.to( that.imageContainer, 0.6, {
                opacity: 0,
                onComplete: function(){
                    gallery.destroy();
                }
            });
        });

    });

};
